export const oops = {
  title: 'Проблема не в тебе, проблема в нас',
  description1: 'Пожалуйста проверь соединение и попробуй еще раз.',
  description2: 'Не помогает?',
  link: 'Напиши админу',
};
